import * as yup from 'yup';

const schema = yup.object().shape({
  codigo: yup.string().min(4).max(100).required(),
});

export default schema;
